import type { Locale } from "@/catalog";

export type ProductEventName = "opportunity_opened" | "prompt_copied";
export type ProductEventPlacement = "home" | "detail";

export async function recordProductEvent(
  event: ProductEventName,
  opportunitySlug: string,
  locale: Locale,
  placement: ProductEventPlacement,
  fetcher: typeof fetch = fetch,
): Promise<void> {
  if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(opportunitySlug)) {
    throw new Error("invalid_opportunity_slug");
  }
  await fetcher("/api/events", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({
      event,
      opportunitySlug,
      locale,
      placement,
    }),
    keepalive: true,
  });
}

export function recordProductEventWithoutBlocking(
  event: ProductEventName,
  opportunitySlug: string,
  locale: Locale,
  placement: ProductEventPlacement,
): void {
  void recordProductEvent(event, opportunitySlug, locale, placement).catch(() => undefined);
}
